const apiUrl = process.env.REACT_APP_API_URL; // process.env.REACT_APP_API_URL

export interface ProductOptions {
  page?: number;
  categories?: string;
  price?: string;
  query?: string;
  size?: string;
  discount?: boolean;
  sort?: number;
  market?: string;
}

export default class ProductService {
  static getProducts(options: ProductOptions = { page: 0 }) {
    let page = options.page;
    let categories = "";
    let price = "";
    let query = "";
    let size = "";
    let discount = "";
    let sort = "";
    let market = "";
    if (options.categories) {
      categories = "&categories=" + options.categories;
    }
    if (options.size) {
      size = "&size=" + options.size;
    }
    if (options.price) {
      price = "&price=" + options.price;
    }
    if (options.query) {
      query = "&q=" + options.query;
    }

    if (options.discount) {
      discount = "&discount=1";
    }
    if (options.sort) {
      sort = "&sort=" + options.sort;
    }
    if (options.market) {
      market = "&market=" + options.market;
    }
    return fetch(
      `${apiUrl}/api/products/?page=${page}${categories}${price}${query}${size}${discount}${sort}${market}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static async getProduitById(id: string) {
    return fetch(`${apiUrl}/api/products/${id}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static async getColors() {
    return fetch(`${apiUrl}/api/products/colors`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static async getSizes() {
    return fetch(`${apiUrl}/api/products/sizes`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }
  static async chekDraft() {
    return fetch(`${apiUrl}/api/products/draft/`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static async getUserProduct() {
    return fetch(`${apiUrl}/api/products/user/`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static async newProduits(product: any) {
    return fetch(`${apiUrl}/api/products/`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(product),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static async editProduits(product: any) {
    return fetch(`${apiUrl}/api/products/edit`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(product),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static async changePrice(product: any) {
    return fetch(`${apiUrl}/api/products/`, {
      method: "PUT",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(product),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static async getCategoriesList() {
    return fetch(`${apiUrl}/api/category/`, {
      method: "GET",
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .catch((error) => this.handleError(error));
  }

  static async deletePhoto(id: string) {
    return fetch(`${apiUrl}/api/media/product/${id}`, {
      method: "DELETE",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .catch((error) => this.handleError(error));
  }

  static async delete(id: number) {
    return fetch(`${apiUrl}/api/products/${id}`, {
      method: "DELETE",
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .catch((error) => this.handleError(error));
  }

  // static getProductById(id:number): Promise<ProductView>{
  //   return fetch('http://127.0.0.1:3001/api/product/'+id)
  //       .then(response => response.json())
  //       .catch(error => this.handleError(error));
  // }
  static handleError(error: Error): void {
    console.error(error);
  }
}
